<template>
  <div class="intervento-ospiti">

    <div class="row" v-if="sezione.length>0 && ruolo!='moderatore'">{{ nomeruolo }}:</div>
    <div v-for="itm in sezione" :key="itm.id"><span v-if="ruolo=='moderatore'">{{ nomeruolo }}: </span>{{itm.nome}}&#160;{{itm.cognome}} ({{itm.nazione}})</div>


<!--
        <div class="row" v-if="sezione.length>0 && ruolo!='moderatore'">
        <div class="col s12 m2 l1">&#160;</div>
        <div class="col s12 m10 l10">{{ nomeruolo }}:</div>
        </div>


    <div v-for="itm in sezione" :key="itm.id">
  
        <div class="row">
        <div class="col s12 m2 l1">&#160;</div>
        <div class="col s12 m10 l10"><span v-if="ruolo=='moderatore'">{{ nomeruolo }}: </span>{{itm.nome}}&#160;{{itm.cognome}}</div>
        </div>



    </div>     
-->
  </div>
</template>

<script>
export default {
  name: 'intervento-ospiti',
  props:{
    programma:0
    ,ruolo: ''
  },
  computed: { 
      nomeruolo: function (){
        let nome=''
        switch (this.ruolo){
          case 'moderatore':
          nome = 'Chair'
          break

          case 'relatore':
          nome = 'Speaker'
          break

          default:
          nome = ''
        }
      return nome
      },
      sezione: function () {
        var isFilter = []
        
       if(typeof this.$teras._programmaospite == 'undefined')
         return isFilter

        if(this.ruolo=='all')
          return this.$teras._programmaospite
       

        for (let item of this.$teras._programmaospite){
          //console.log(item)
            //console.log(item.programma+': '+item.ruolo)
            if(item.programma == this.programma  && item.ruolo.toLowerCase() == this.ruolo.toLowerCase())
 
            
              isFilter.push(item)
        }
        
        return isFilter
      }
      
  }
}
</script>


<style>

</style>
